module.exports = __webpack_public_path__ + "static/hashtagGraphic-2c1514f6c8aae955079e01b42b178e05.svg";